// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-menu .user-info {
  height: 100px;
  width: 250px;
  box-shadow: none !important;
}
.user-menu .user-info img {
  border-radius: 50%;
  width: 80px;
  height: 80px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.user-menu .user-info h2 {
  font-size: 16px;
  font-weight: 400;
}
.user-menu .user-info h3 {
  font-size: 14px;
  font-weight: 400;
}
.user-menu .user-info p {
  font-size: 12px;
}
.user-menu .mat-menu-item,
.user-menu .mat-mdc-menu-item {
  font-size: 14px;
  height: 36px;
  line-height: 36px;
}`, "",{"version":3,"sources":["webpack://./src/app/theme/components/user-menu/user-menu.component.scss"],"names":[],"mappings":"AAII;EACI,aAAA;EACA,YAAA;EACA,2BAAA;AAHR;AAIQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;AAFZ;AAIQ;EACI,eAAA;EACA,gBAAA;AAFZ;AAIQ;EACI,eAAA;EACA,gBAAA;AAFZ;AAIQ;EACI,eAAA;AAFZ;AAKI;;EAEI,eAAA;EACA,YAAA;EACA,iBAAA;AAHR","sourcesContent":["// ==========================================================================\r\n// Component: User-menu.component\r\n// ==========================================================================\r\n.user-menu{\r\n    .user-info{\r\n        height: 100px;\r\n        width: 250px;\r\n        box-shadow: none !important;        \r\n        img{\r\n            border-radius: 50%;\r\n            width: 80px;\r\n            height: 80px;\r\n            border: 1px solid rgba(0, 0, 0, 0.12); \r\n        }\r\n        h2{\r\n            font-size: 16px;\r\n            font-weight: 400;\r\n        }\r\n        h3{\r\n            font-size: 14px;\r\n            font-weight: 400;\r\n        }\r\n        p{\r\n            font-size: 12px;\r\n        }\r\n    }\r\n    .mat-menu-item,\r\n    .mat-mdc-menu-item{\r\n        font-size: 14px;\r\n        height: 36px;\r\n        line-height: 36px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
